import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import NewTaskModal from '../TaskManagement/TaskComponents/NewTaskModal'
import CommsNewConversationModal from '../Communication/CommsNewConversationModal'

function GlobalNewTaskButton() {
    const [isTaskOpen, setIsTaskOpen] = useState(false)
    const [isMessageOpen, setIsMessageOpen] = useState(false)
    const location = useLocation()

    const driverMatch = location.pathname.match(/^\/driver\/([^/]+)/)
    const incidentMatch = location.pathname.match(/^\/incident\/([^/]+)/)

    const filterValues = {}
    if (driverMatch) filterValues.driverId = driverMatch[1]
    if (incidentMatch) filterValues.incidentId = incidentMatch[1]

    return (
        <>
            <UncontrolledDropdown>
                <DropdownToggle color="light">
                    <i className="fa fa-plus" aria-hidden="true" style={{ color: "#525f7f" }} />
                </DropdownToggle>
                <DropdownMenu right>
                    <DropdownItem onClick={() => setIsTaskOpen(true)}>
                        <i className="fa fa-tasks" style={{ color: "#525f7f" }} />&nbsp;&nbsp;New Task
                    </DropdownItem>
                    <DropdownItem onClick={() => setIsMessageOpen(true)}>
                        <i className="fa fa-envelope" style={{ color: "#525f7f" }} />&nbsp;&nbsp;New Message
                    </DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
            {isTaskOpen && (
                <NewTaskModal
                    isOpen={isTaskOpen}
                    closeModal={() => setIsTaskOpen(false)}
                    filterValues={filterValues}
                />
            )}
            {isMessageOpen && (
                <CommsNewConversationModal
                    isOpen={isMessageOpen}
                    toggle={() => setIsMessageOpen(false)}
                    defaultDriverId={filterValues.driverId || null}
                />
            )}
        </>
    )
}

export default GlobalNewTaskButton
